/**
 * External Dependencies
 */
import 'jquery';
jQuery.migrateMute = true;
//import 'bootstrap';
import 'slick-carousel';
import { Tooltip, Carousel } from 'bootstrap';
import '@fancyapps/fancybox';

import woocommerce from './partials/woocommerce';
import { initFilterProducts } from './partials/productsFilter';
import { initCheckboxVariations } from './partials/productVariations';

$(document).ready(() => {
  initCheckboxVariations($('.product_cart_inpage'), 0);
  initFilterProducts();
  woocommerce;

  /* Bouton Acheter */
  $('.btn-product-shop').on('click', function() {
    var obj = this;
    var product_id = $(obj).data('product_id');
    $.fancybox.open('', {
      beforeShow: function() {
        $('.fancybox-slide').addClass('d-none');
      },
    });
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'load_variations',
        product_id: product_id,
      },
    }).done(function(response) {
      $.fancybox.close();
      $.fancybox.open(response, {
        modal: false,
        protect: false,
        touch: {
          vertical: false,
        },
        afterLoad: function() {
          initCheckboxVariations($('.product_cart_inbox'), product_id);
        },
        clickSlide: false,
      });
    });
    return false;
  });
  /* */

  /* Shop Filters */
  $('#shop_categories .post-type-archive-product__btn-categories-show').on(
    'click',
    function() {
      if (!$('#shop_categories').hasClass('opened')) {
        $(this).fadeToggle(350, function() {
          $('#shop_categories').addClass('opened');
          $('#shop_categories .post-type-archive-product__categories').fadeIn(
            350
          );
        });
      }
    }
  );

  $('#shop_categories .post-type-archive-product__btn-categories-hide').on(
    'click',
    function() {
      if ($('#shop_categories').hasClass('opened')) {
        $('#shop_categories .post-type-archive-product__categories').fadeOut(
          350,
          function() {
            $('#shop_categories').removeClass('opened');
            $(
              '#shop_categories .post-type-archive-product__btn-categories-show'
            ).fadeIn(350);
          }
        );
      }
    }
  );
  /* */

  /* Checkout textarea gift */
  $('#wc_ship_to_billing_gift_checkbox').on('change', function() {
    if ($(this).is(':checked')) {
      $('#wc_ship_to_billing_gift .wc_ship_to_billing_gift_textarea').slideDown(
        350
      );
    } else {
      $('#wc_ship_to_billing_gift .wc_ship_to_billing_gift_textarea').slideUp(
        350
      );
    }
  });
  /* */

  var timeout;
  // Submit after quantity change
  $('.woocommerce').on('change', 'input.qty', function() {
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(function() {
      $("[name='update_cart']").trigger('click');
    }, 500);
  });

  $('.blocks-gallery-item a, .woocommerce-product-gallery__image a')
    .attr('data-fancybox', 'gallery')
    .fancybox();

  /** Enable tooltips everywhere */
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.map(function(tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
  });

  if (document.querySelector('#carouselHomeVins')) {
    var carouselHomeVins = document.querySelector('#carouselHomeVins');
    var carousel = new Carousel(carouselHomeVins, {});
    initCarousel(carousel);
  }

  //initEquipe();

  /** Enable collapse widgets */
  $(window).on('resize', function() {
    if (findBootstrapEnvironment() != 'xs') {
      $('.widget > div').show();
    } else {
      $('.widget > div').hide();
      $('.widget > h3').removeClass('collapsed');
    }
    if (carousel) {
      initCarousel(carousel);
    }
    //initEquipe();
    // if(findBootstrapEnvironment()=='sm' || findBootstrapEnvironment()=='md'){
    //   document.getElementById("mainNavbarToggler").classList.remove("is-active");
    //   document.getElementById("mainNavbar").classList.add("collapsed");
    // }
  });

  // if(findBootstrapEnvironment()=='sm' || findBootstrapEnvironment()=='md'){
  //   document.getElementById("mainNavbarToggler").classList.remove("is-active");
  //   document.getElementById("mainNavbar").classList.add("collapsed");
  // }

  $('.widget > h3').click(function() {
    if (findBootstrapEnvironment() == 'xs') {
      if (
        $(this)
          .next('div')
          .is(':visible')
      ) {
        $(this).removeClass('collapsed');
      } else {
        $(this).addClass('collapsed');
      }
      $(this)
        .next('div')
        .toggle(250);
    }
    return false;
  });

  /**
   * Animation du menu
   */
  let mainNavbar = document.getElementById('mainNavbar');
  let mainNavbarToggler = document.getElementById('mainNavbarToggler');

  mainNavbarToggler.onclick = () => {
    setTimeout(() => {
      mainNavbarToggler.classList.toggle('is-active');
    }, 200);
    mainNavbar.classList.toggle('collapsed');
  };

  if (window.matchMedia('(min-width: 992px)').matches) {
    let prevScrollpos = window.pageYOffset;

    window.onscroll = () => {
      let currentScrollPos = window.pageYOffset;

      if (prevScrollpos > currentScrollPos) {
        if (
          findBootstrapEnvironment() != 'sm' &&
          findBootstrapEnvironment() != 'md'
        ) {
          mainNavbarToggler.classList.add('is-active');
          mainNavbar.classList.remove('collapsed');
        }
      } else {
        mainNavbarToggler.classList.remove('is-active');
        mainNavbar.classList.add('collapsed');
      }
      prevScrollpos = currentScrollPos;
    };
  } else {
    mainNavbarToggler.classList.remove('is-active');
    mainNavbar.classList.add('collapsed');
  }

  /**
   * Effets au scroll
   */
  const threshold = 0.5;
  const options = {
    root: null,
    rootMargin: '0px',
    threshold,
  };

  const handleIntersect = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > threshold) {
        entry.target.classList.remove('reveal');
        observer.unobserve(entry.target);
      }
    });
  };

  document.documentElement.classList.add('reveal-loaded');

  const observer = new IntersectionObserver(handleIntersect, options);
  const targets = document.querySelectorAll('.reveal');
  targets.forEach(function(target) {
    observer.observe(target);
  });

  /**
   * Couleur dynamique du background
   */
  let root = document.documentElement;
  let pageContent = document.getElementById('page__content');
  root.style.setProperty(
    '--page-background-color',
    pageContent.dataset.backgroundColor
  );

  /**
   * Bootstrap Events for Contact Form 7
   * Validation Events for changing response CSS classes
   */
  $('.wpcf7-response-output').removeClass('alert');
  document.addEventListener(
    'wpcf7invalid',
    function() {
      $('.wpcf7-response-output').addClass('alert alert-danger');
    },
    false
  );
  document.addEventListener(
    'wpcf7spam',
    function() {
      $('.wpcf7-response-output').addClass('alert alert-warning');
    },
    false
  );
  document.addEventListener(
    'wpcf7mailfailed',
    function() {
      $('.wpcf7-response-output').addClass('alert alert-warning');
    },
    false
  );
  document.addEventListener(
    'wpcf7mailsent',
    function() {
      $('.wpcf7-response-output').addClass('alert alert-success');
    },
    false
  );

  $('.dr-block-equipe__slide').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// function initEquipe(){
//   if(findBootstrapEnvironment()!='md' && findBootstrapEnvironment()!='lg' && findBootstrapEnvironment()!='xl' && findBootstrapEnvironment()!='xxl'){
//     if($('.dr-block-equipe .dr-block-equipe__membre > .dr-block-equipe__membre__nom').length<=0){
//       $('.dr-block-equipe .dr-block-equipe__membre .dr-block-equipe__membre__nom').each(function(){
//         $(this).parent('.dr-block-equipe__membre__header').parent('.iscollapse').parent('.dr-block-equipe__membre').prepend($(this));
//       });
//       $('.dr-block-equipe .dr-block-equipe__membre .dr-block-equipe__membre__nom').attr('data-bs-toggle','collapse');
//       $('.dr-block-equipe .iscollapse').addClass('collapse');
//     }
//   }else{
//     $('.dr-block-equipe .iscollapse').removeClass('collapse');
//     if($('.dr-block-equipe .dr-block-equipe__membre > .dr-block-equipe__membre__nom').length>0){
//       $('.dr-block-equipe .dr-block-equipe__membre > .dr-block-equipe__membre__nom').each(function(){
//         $(this).parent('.dr-block-equipe__membre').find('.dr-block-equipe__membre__photo').after($(this));
//       });
//       $('.dr-block-equipe .dr-block-equipe__membre .dr-block-equipe__membre__nom').removeAttr('data-bs-toggle');
//       $('.dr-block-equipe .iscollapse').removeClass('collapse');
//     }
//   }
// }

function initCarousel(carousel) {
  if (
    findBootstrapEnvironment() != 'lg' &&
    findBootstrapEnvironment() != 'xl' &&
    findBootstrapEnvironment() != 'xxl'
  ) {
    $('#carouselHomeVins .row').addClass('carousel-inner');
    $('#carouselHomeVins .col').addClass('carousel-item');
    $('#carouselHomeVins').addClass('carousel');
    carousel.cycle();
  } else {
    carousel.pause();
    $('#carouselHomeVins').removeClass('carousel');
    $('#carouselHomeVins .row').removeClass('carousel-inner');
    $('#carouselHomeVins .col').removeClass('carousel-item');
  }
}

$('body').append(
  '<div id="bootstrap5envs">' +
    '<div class="d-block d-sm-none" data-env="xs"></div>' +
    '<div class="d-none d-sm-block d-md-none" data-env="sm"></div>' +
    '<div class="d-none d-md-block d-lg-none" data-env="md"></div>' +
    '<div class="d-none d-lg-block d-xl-none" data-env="lg"></div>' +
    '<div class="d-none d-xl-block d-xxl-none" data-env="xl"></div>' +
    '<div class="d-none d-xxl-block" data-env="xxl"></div>' +
    '</div>'
);

function findBootstrapEnvironment() {
  var env = 'xs';
  $('#bootstrap5envs > div').each(function() {
    if ($(this).is(':visible')) {
      env = $(this).attr('data-env');
    }
  });
  return env;
}
